import { render, staticRenderFns } from "./roomGameDetails.vue?vue&type=template&id=8920a2b0&lang=pug&"
import script from "./roomGameDetails.vue?vue&type=script&lang=js&"
export * from "./roomGameDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports